<template>
    <!-- 右边主体[[ -->
    <div class="g-content">
        <!-- 自由投稿 -->
        <div class="contribution">
            <!-- 编辑区域 -->
            <div class="complie">
                <hint-real-name @getUserIdentity="getUserIdentity" :showPrivate="true"></hint-real-name>
                <div class="header">
                    <i class="ico-writing ico-step1"></i>
                    <div class="tag">编辑内容</div>
                    <!-- 选项卡，点击切换内容 start -->
                    <div class="g-tab">
                        <a href="javascript:;" v-for="(item,index) in tabList" :key="index" @click="changeTabTip(index)">
                            <div class="g-tab-item" :class="{'g-tab-item-active': index == curTab}">{{item.name}}</div>
                        </a>
                    </div>
                    <!-- 选项卡，点击切换内容 end -->
                </div>
                <!-- 图文内容可编辑区域[[ -->
                <transition name="page">
                    <picture-tab v-show="curTab == 0" ref="picCnt"></picture-tab>
                </transition>
                <!-- 图文内容可编辑区域]] -->
                <transition name="page">
                    <!-- 视频内容可编辑区域[[ -->
                    <video-tab v-show="curTab == 1" ref="videoCnt" @videoPublish="addVideo" @delVideo="initVideo"></video-tab>
                </transition>
                <!-- 视频内容可编辑区域]] -->
            </div>
            <!-- 发布渠道[[ -->
            <div class="publish" v-show="showPublish">
                <div class="header">
                    <i class="ico-writing ico-step2"></i>
                    <div class="tag">发布渠道</div>
                </div>
                <div class="edit-content">
                    <div class="channel-group">
                        <div class="channel-left-con f-inlineblock-top" :class="{'show-all': showAll}">
                            <div class="channel-item">
                                <div class="channel-icon-block personal">
                                    <div class="channel-icon channel-icon-border"></div>
                                    <img class="channel-img" :src="channelObj.logo" alt="" srcset="">
                                    <i class="ico-writing ico-account-confirm"></i>
                                    <div class="channel-name" style="font-size: 12px;"> {{channelObj.name}}</div>
                                    <div class="channel-subname">
                                        <div class="channel-subname-text" style="font-size: 12px" :title="channelObj.subname">
                                            {{channelObj.subname}}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="channel-item" v-for="(item,index) in mediaList" :key="item.enName"
                                @click.stop="selectMedia(item)">
                                <div class="channel-icon-block personal" :class="{'overduce': item.curAccount.expire == 1}">
                                    <!-- 点击未过期的第一方渠道图标，加上边框及右上角出现钩子角标 -->
                                    <div class="channel-icon" :class="{'channel-icon-border': selectMediaEnNameList.indexOf(item.enName)!=-1}"></div>

                                    <img class="channel-img" :src="item.logo" alt>
                                    <i class="ico-writing ico-account-confirm" v-show="selectMediaEnNameList.indexOf(item.enName)!=-1"></i>
                                    <i class="ico-writing ico-account-warn" v-if="item.curAccount.expire == 1"></i>
                                    <div class="overdue-date-tooltip" v-if="item.curAccount.expire == 1">已过期</div>
                                </div>
                                <div class="channel-name">{{item.name}}</div>
                                <div class="channel-subname">
                                    <div class="channel-subname-text">{{item.curAccount.accountName}}</div>
                                    <i class="ico-writing account-btn" :class="[item.show ? 'ico-account-drap-up' : 'ico-account-drap-down']"
                                        @click.stop="showDropdown(item,index)"></i>
                                    <!-- 点击显示下拉框 -->
                                    <div class="g-tooltip channel-selector" v-show="item.show">
                                        <div class="g-tooltip-arrows-up"></div>
                                        <div class="selector-content g-scrollbar">
                                            <div class="selector-item" :class="{'fail-status': accountItem.expire == 1}"
                                                v-for="accountItem in item.account" :key="accountItem.id"
                                                @click.stop="selectAccount(index,accountItem,item)">
                                                <img class="select-icon" :src="accountItem.accountHeader"
                                                    :alt="accountItem.accountName">
                                                <i class="ico-writing ico-fail" v-if="accountItem.expire"></i>
                                                <span class="selector-item-name" :class="{'fail-tips-name': accountItem.expire}"
                                                    :title="accountItem.accountName">{{accountItem.accountName}}</span>
                                                <span class="fail-tips" v-if="accountItem.expire">授权已失败</span>
                                            </div>
                                            <div class="selector-cancel" @click.stop="showDropdown(item,index)">取消</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="channel-item" v-for="item in noBindMediaList" :key="item.enName"
                                @click="BindMediaIframe(item)" v-if="item.enName != 'iqiyi' && item.enName != 'weibo'">
                                <div class="channel-icon-block">
                                    <div class="channel-icon"></div>
                                    <img class="channel-img" :src="item.src" :alt="item.name">
                                </div>
                                <div class="channel-name">{{item.name}}</div>
                            </div>
                        </div>
                        <!-- 点击展示更多发布渠道选项【【 -->
                        <div class="channel-item channel-more-btn js-more-btn" v-show="mediaList.length+noBindMediaList.length>6"
                            @click="showAll = !showAll">
                            <div class="channel-icon-block channel-btn">
                                <img v-if="!showAll" class="channel-icon more-platform" src="~Assets/img/pages/v4/icon-more-platform.png"
                                    alt="更多平台">
                                <img v-if="showAll" class="channel-icon more-platform-active" src="~Assets/img/pages/v4/icon-more-platform-active.png"
                                    alt="更多平台">
                            </div>
                            <div class="channel-name color-theme">更多平台</div>
                        </div>
                    </div>
                    <!-- 显示或隐藏个性编辑区域内容 -->
                    <div class="personal-edit">
                        <div class="personal-edit-header">
                            <span class="auto-auth" @click="autoEditor" v-show="autoAuth">个性编辑</span>
                            <span class="auto-auth" @click="autoEditor" v-show="!autoAuth">智能编辑</span>
                            <i @click="autoEditor" class="ico-writing ico-drap-down" v-show="autoAuth"></i>
                            <i @click="autoEditor" class="ico-writing ico-drap-up" v-show="!autoAuth"></i>
                        </div>
                        <!-- 7.5修改 -->
                        <ul class="personal-edit-content" v-show="!autoAuth">
                            <!-- 选中的媒体发布渠道 -->
                            <li class="f-clearfix pec-list" v-for="item in selectMediaList" :key="item.enName">
                                <div class="img-upload">
                                    <tgl-image-cloud-upload class="hide-add-icon" v-if="!autoAuth" style="display: inline-block"
                                        :btnId="item.enName" :isCrop="true" :domWidth="207" :ref="'imgUpload'+item.enName"
                                        @completed="imageUploadCompleted" :choiceType="item">
                                        <template #text>
                                            <div class="upload-text">点击上传封面图片</div>
                                            <div class="upload-text">不传显示文章统一封面</div>
                                        </template>
                                        <template #footer>
                                            <div style="font-size: 14px;">{{item.name}}</div>
                                        </template>
                                    </tgl-image-cloud-upload>
                                </div>
                                <div class="text-block">
                                    <div class="title">
                                        <input class="title-textarea" rows="1" maxlength="30" v-model="item.title"
                                            placeholder="请输入内容标题（30个字以内）">
                                    </div>
                                    <div class="introduction">
                                        <textarea v-model="item.summary" class="introduction-textarea"
                                            maxlength="200" placeholder="填写简介（10-50个字符）"></textarea>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="footer-bar">
                    <!-- 6.29修改 -->
                    <div class="footer-bar-btn">
                        <div class="g-bottom-btn btn-group">
                            <a class="button js-cancel-btn" href="javascript:;" @click="cancel">取消</a>
                            <a class="button preview-btn" href="javascript:;" @click="showPreview">预览</a>
                            <a class="button" href="javascript:;" @click="saveDraft">存草稿</a>
                            <a class="button bg-btn" href="javascript:;" @click="publish">发布</a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 发布渠道]] -->
        </div>
        <!-- 第三方弹窗[[ -->
        <bind-media ref="mediaRef" @bindResult="loadMedia"></bind-media>
        <!-- 第三方弹窗]] -->
    </div>
    <!-- 右边主体]] -->
</template>
<style lang="scss" scoped>
@import '~Assets/sass/pages/v4/contribute/contribute.scss';
#chart-wrap {
    width: 100%;
    height: 250px;
}
.channel-left-con {
    height: 172px;
    // overflow: hidden;
    &.show-all {
        height: auto;
    }
}
.auto-auth {
    cursor: pointer;
}
.hide-add-icon {
    /deep/ .icon-plus {
        display: none;
    }
}
</style>
<script>
import pictureTab from "./_picture";
import videoTab from "./_video";
import bindMedia from "Components/v4/pop/bind_media.vue";
import hintRealName from "Components/v4/hint/real_name.vue";
import { MediaUserAccountGroup, DraftDetail } from "Services/getData";
export default {
    data() {
        return {
            showAll: false,
            tabList: [
                {
                    name: "图文内容",
                    val: 0
                },
                {
                    name: "视频内容",
                    val: 1
                }
            ],
            curTab: "",
            showPublish: true,
            asyncmedia: [],
            mediaList: [],
            mediaAll: [
                {
                    name: "爱奇艺",
                    enName: "iqiyi",
                    src: require("../../../assets/img/pages/v4/iqiyi.png")
                },
                {
                    name: "优酷",
                    enName: "youku",
                    src: require("../../../assets/img/pages/v4/youku.png")
                },
                {
                    name: "企鹅号",
                    enName: "om",
                    src: require("../../../assets/img/pages/v4/om.png")
                },
                {
                    name: "微博",
                    enName: "weibo",
                    src: require("../../../assets/img/pages/v4/weibo.png")
                },
                // {name: '头条', enName: 'toutiao',src: require('../../../assets/img/pages/v4/toutiao.png')},
                {
                    name: "大鱼号",
                    enName: "dayu",
                    src: require("../../../assets/img/pages/v4/dayu.png")
                },
                {
                    name: "百家号",
                    enName: "baijiahao",
                    src: require("../../../assets/img/pages/v4/baijiahao.png")
                },
                // {
                //     name: "看点",
                //     enName: "kandian",
                //     src: require("../../../assets/img/pages/v4/kandian.png")
                // },
                {
                    name: "腾讯视频",
                    enName: "vqq",
                    src: require("../../../assets/img/pages/v4/vqq.png")
                }
            ],
            noBindMediaList: [],
            selectMediaList: [],
            autoAuth: true, //智能编目开关
            mediaChangeNum: 0,
            interval: "",
            channelObj: {
                name: '腾讯游戏',
                subname: '官网、微社区等腾讯游戏官方渠道',
                logo: require("../../../assets/img/pages/v4/gamelogo.jpg"),
            },
        };
    },
    computed: {
        selectMediaEnNameList() {
            let list = [];
            this.selectMediaList.forEach((v, k) => {
                list.push(v.enName);
            });
            return list;
        }
    },

    components: {
        pictureTab,
        videoTab,
        bindMedia,
        hintRealName
    },
    async mounted() {
        await this.loadMedia();
        this.$nextTick(() => {
            if (this.$route.query.draftId) {
                this.getDraft();
            } else {
                this.getDefaultMedia();
            }
            if (this.$route.query.cmeId) {
                this.cmeContribute(this.$route.query.cmeId);
            }
            this.mediaChange();
        });
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
    methods: {
        cmeContribute(cmeId) {
            this.curTab = 1;
            this.changeTab(this.curTab);
            this.showPublish = true;
            this.$refs.videoCnt.hasVideo = true;
            this.$refs.videoCnt.cmeContribute(cmeId);
        },
        mediaChange() {
            this.interval = setInterval(() => {
                if (
                    this.$common.getSessionStore("mediaChange") ==
                    this.mediaChangeNum
                ) {
                    return;
                } else {
                    this.mediaChangeNum = this.$common.getSessionStore(
                        "mediaChange"
                    );
                }
            }, 1000);
        },
        async getUserIdentity(data) {
            this.$refs.picCnt.userIdentityData = data;
            this.$refs.videoCnt.userIdentityData = data;
        },
        imageUploadCompleted(res) {
            this.selectMediaList.forEach((v, k) => {
                if (v.enName == res.btnId) {
                    v.cover = res.url;
                }
            });

            // debugger;
        },
        selectMedia(item, from) {
            if (!this.checkMedia(item)) return;

            // 判断媒体是否过期
            if (item.curAccount.expire == 1) {
                this.$confirm(
                    "账号授权已过期,是否前往媒体账号重新绑定?",
                    "提示",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }
                )
                    .then(() => {
                        this.$router.push({
                            name: "v4-manage-account"
                        });
                    })
                    .catch(() => { });
            } else {
                // 媒体选择-是否已存在
                let exist = -1;
                if (this.selectMediaList) {
                    this.selectMediaList.forEach((v, k) => {
                        if (v.enName == item.enName) {
                            exist = k;
                        }
                    });
                }
                if (exist == -1) {
                    item.cover = "";
                    item.title = "";
                    item.summary = "";
                    this.selectMediaList.push(item);
                } else {
                    if (!from) {
                        this.selectMediaList.splice(exist, 1);
                    }
                }
            }
        },
        selectAccount(index, accountItem, item) {
            // 账号选择
            if (accountItem.expire == 1) {
                this.$confirm(
                    "账号授权已过期,是否前往媒体账号重新绑定?",
                    "提示",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }
                )
                    .then(() => {
                        this.$router.push({
                            name: "v4-manage-account"
                        });
                    })
                    .catch(() => { });
            } else {
                if (!this.checkMedia(item, accountItem)) return;

                let list = this.mediaList;
                this.mediaList = "";
                list[index].curAccount = accountItem;
                list[index].show = false;
                this.mediaList = list;
                this.selectMedia(item, "selectAccount");
            }
        },
        checkMedia(item, accountItem) {
            let curAccount;
            accountItem
                ? (curAccount = accountItem)
                : (curAccount = item.curAccount);
            // 判断企鹅号和腾讯视频是否为同一个账号
            let hasDiffCount = true;
            this.selectMediaList.filter(m => {
                if (
                    m.enName == "om" &&
                    item.enName == "vqq" &&
                    m.curAccount.qq != curAccount.qq
                ) {
                    if (!m.curAccount.qq) {
                        this.$alert("请先前往企鹅号官网绑定QQ账号");
                    } else {
                        this.$alert(
                            "企鹅号、 腾讯视频同时选择时，只能选相同的QQ账号分发~"
                        );
                    }
                    hasDiffCount = false;
                }
                if (
                    m.enName == "vqq" &&
                    item.enName == "om" &&
                    m.curAccount.qq != curAccount.qq
                ) {
                    if (!curAccount.qq) {
                        this.$alert("请先前往企鹅号官网绑定QQ账号");
                    } else {
                        this.$alert(
                            "企鹅号、 腾讯视频同时选择时，只能选相同的QQ账号分发~"
                        );
                    }
                    hasDiffCount = false;
                }
            });
            if (!hasDiffCount) {
                return false;
            } else {
                return true;
            }
        },
        getDefaultMedia() {
            if (localStorage.getItem('defaultMedia')) {
                let selectMediaList = JSON.parse(localStorage.getItem('defaultMedia'));
                selectMediaList.forEach((v, k) => {
                    this.$nextTick(() => {
                        this.asyncmedia.forEach((j, i) => {
                            j.account.forEach((j2, i2) => {
                                if (j2.id == v.accountId && !j2.expire) {
                                    j.curAccount = j2;
                                    this.selectMediaList.push(j);
                                }
                            });
                        });
                    });
                });
            }
        },
        async getDraft() {
            let res = await DraftDetail(this.$route.query.draftId);
            let data = res.data.data;
            if (!data) {
                this.$alert("草稿不存在");
                return;
            }
            (data.articleType == 0) ? this.curTab = 0 : this.curTab = 1;
            this.changeTab(this.curTab);

            // this.mediaList = [];
            if (data.content.mediaInfo) {
                let selectMediaList = JSON.parse(data.content.mediaInfo);
                selectMediaList.forEach((v, k) => {
                    if (v.title || v.cover || v.summary) {
                        this.autoAuth = false;
                    }
                    this.$nextTick(() => {
                        this.asyncmedia.forEach((j, i) => {
                            j.account.forEach((j2, i2) => {
                                if (j2.id == v.accountId) {
                                    j.curAccount = j2;
                                    j.title = v.title;
                                    j.summary = v.summary;
                                    j.cover = v.cover;
                                    this.selectMediaList.push(j);
                                }
                            });
                        });
                    });
                });
            } else {
                this.getDefaultMedia();
            }
            console.log(this.selectMediaList);
            if (data.articleType == 0) {
                this.curTab = 0;
                this.$refs.picCnt.getDraft(data, this.autoAuth);
            } else {
                this.curTab = 1;
                this.showPublish = true;
                this.$refs.videoCnt.hasVideo = true;
                this.$refs.videoCnt.getDraft(data, this.autoAuth);
            }
        },
        paramHasSet(param) {
            let keys = Object.keys(param);
            let isSet = false;
            keys.map(item => {
                if (
                    param[item] != undefined &&
                    isNaN(param[item]) &&
                    param[item].length > 0
                ) {
                    isSet = true;
                } else if (param[item] > 0) {
                    isSet = true;
                }
            });
            return isSet;
        },
        changeTabTip(index) {
            if (index !== this.curTab) {
                let auth = false;
                if (this.curTab == 0) {
                    auth = this.paramHasSet(this.$refs.picCnt.paramHasSet());
                }
                if (this.curTab == 1) {
                    auth = this.paramHasSet(this.$refs.videoCnt.paramHasSet());
                }
                if (auth) {
                    this.$confirm("系统可能不会保存您所做的更改", "确认信息", {
                        distinguishCancelAndClose: true,
                        confirmButtonText: "确认",
                        cancelButtonText: "取消"
                    }).then(() => {
                        this.changeTab(index);
                        this.resetPage();
                        this.getDefaultMedia();
                    }).catch(action => {
                        return;
                    });
                } else {
                    this.changeTab(index);
                    this.resetPage();
                    this.getDefaultMedia();
                }
            }
        },
        changeTab(index = 0) {
            if (this.curTab !== index) {
                this.curTab = index;
                this.autoAuth = true;
                this.selectMediaList = [];
                this.showPublish = index == 0 ? true : false;
                this.$refs.videoCnt.hasVideo = false;
                this.$refs.videoCnt.delVideoFile();
            }
            this.filterMedia();
        },
        filterMedia() {
            // 媒体渠道筛选
            this.noBindMediaList = this.mediaAll.slice();
            let mediaEnNameAll = [];
            this.mediaAll.forEach((v, k) => {
                mediaEnNameAll.push(v.enName);
            });
            this.mediaList = [];
            if (this.curTab == 0) {
                this.asyncmedia.forEach((v, k) => {
                    if (
                        mediaEnNameAll.indexOf(v.enName) != -1 &&
                        v.enName != "iqiyi" &&
                        v.enName != "youku" &&
                        v.enName != "vqq"
                    ) {
                        this.mediaList.push(v);
                    }
                    v.show = false;
                    v.curAccount = v.account[0];
                    for (let i = 0; i < this.noBindMediaList.length; i++) {
                        if (
                            v.enName == this.noBindMediaList[i].enName ||
                            this.noBindMediaList[i].enName == "iqiyi" ||
                            this.noBindMediaList[i].enName == "youku" ||
                            this.noBindMediaList[i].enName == "vqq"
                        ) {
                            this.noBindMediaList.splice(i, 1);
                            --i;
                        }
                    }
                    // this.noBindMediaList.forEach( (b,i) => {
                    //     if((v.enName == b.enName) || b.enName == 'iqiyi' || b.enName == 'youku'){
                    //         this.noBindMediaList.splice(i,1);
                    //     }
                    // })
                });
            } else {
                this.asyncmedia.forEach((v, k) => {
                    if (mediaEnNameAll.indexOf(v.enName) != -1) {
                        this.mediaList.push(v);
                    }
                    v.show = false;
                    v.curAccount = v.account[0];
                    this.noBindMediaList.forEach((b, i) => {
                        if (v.enName == b.enName) {
                            this.noBindMediaList.splice(i, 1);
                        }
                    });
                });
            }
        },
        addVideo() {
            this.showPublish = true;
            console.log("addVideo");
        },
        initVideo() {
            if (this.curTab == 1) {
                this.showPublish = false;
                console.log("initVideo");
            }
        },
        async loadMedia() {
            let res = await MediaUserAccountGroup();
            if (res.status === 200 && res.data.code === 0) {
                this.asyncmedia = res.data.data;
                this.changeTab(this.curTab);
            }
        },
        showDropdown(item, index) {
            let status = item.show;
            let list = this.mediaList;
            this.mediaList = "";
            list.forEach((v, k) => {
                v.show = false;
            });
            list[index].show = !status;
            this.mediaList = list;
            console.log("drop");
        },
        saveDraft() {
            if (this.curTab == 0) {
                this.$refs.picCnt.saveDraft(
                    this.selectMediaList,
                    this.autoAuth
                );
            }
            if (this.curTab == 1) {
                this.$refs.videoCnt.saveDraft(
                    this.selectMediaList,
                    this.autoAuth
                );
            }
        },
        publish() {
            console.log(this.selectMediaList)
            if (this.selectMediaList.length) {
                let defaultMedia = []
                this.selectMediaList.forEach((v, k) => {
                    let mediaInfo = {};
                    // debugger
                    mediaInfo.accountId = v.curAccount.id;
                    defaultMedia.push(mediaInfo);
                })
                localStorage.setItem('defaultMedia', JSON.stringify(defaultMedia))
            }
            if (this.curTab == 0) {
                this.$refs.picCnt.publish(this.selectMediaList, this.autoAuth);
            }
            if (this.curTab == 1) {
                this.$refs.videoCnt.publish(
                    this.selectMediaList,
                    this.autoAuth
                );
            }
        },
        resetPage() {
            this.autoAuth = true;
            this.selectMediaList = [];
            if (this.curTab == 0) {
                this.$refs.picCnt.resetPage();
            }
            if (this.curTab == 1) {
                this.$refs.videoCnt.resetPage();
            }
        },
        cancel() {
            this.$confirm("系统可能不会保存您所做的更改", "确认信息", {
                distinguishCancelAndClose: true,
                confirmButtonText: "确认",
                cancelButtonText: "取消"
            })
                .then(() => {
                    // this.saveDraft();
                    this.resetPage();
                })
                .catch(action => { });
        },
        showPreview() {
            if (this.curTab == 0) {
                this.$refs.picCnt.showPreview();
            }
            if (this.curTab == 1) {
                this.$refs.videoCnt.showPreview();
            }
        },
        async BindMediaIframe(media) {
            this.$refs.mediaRef.BindMediaIframe(media);
        },
        autoEditor() {
            if (this.autoAuth) {
                this.$confirm(
                    "在个性编目状态下。标题和封面图的修改只会同步到对应的渠道",
                    "确认开启个性编辑？",
                    {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消"
                    }
                )
                    .then(() => {
                        this.autoAuth = false;
                    })
                    .catch(() => { });
            } else {
                this.$confirm(
                    "在智能编目状态下。标题和封面图的修改会同步到对应的渠道",
                    "确认开启智能编辑？",
                    {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消"
                    }
                )
                    .then(() => {
                        this.autoAuth = true;
                    })
                    .catch(() => { });
            }
        }
    },
    watch: {
        autoAuth(val, oldval) {
            if (oldval) {
                // 切换成个性编辑时，同步标题和cover
                if (this.curTab == 0) {
                    this.$refs.picCnt.getAuthInfo(this.selectMediaList, val);
                }
                if (this.curTab == 1) {
                    this.$refs.videoCnt.getAuthInfo(this.selectMediaList, val);
                }
            } else {
            }
        },
        mediaChangeNum(val) {
            this.loadMedia();
        }
    }
};
</script>
